import React, { Component } from "react";
import { connect } from "react-redux";
import Table from "../table/Table";
import {
  fetchProcessingOrders,
  getOrderDetailsForPage,
} from "../../homeActions";
import Paginater from "../table/Paginater";
import { Button } from "antd";
import { openModal } from "../../../modal/modalActions";
import {
  getUserPermissions,
  getUserType,
  lenswareStatusUserMapping,
} from "../../../../app/common/util/genericUtils";
import { PermissibleRender } from "@brainhubeu/react-permissible";
import MobileOrderActions from "../MobileOrderActions";
import {
  ORDER_LIST_PAGE_SIZE,
  getOrderRowClassName,
  renderOrderNumberCell,
  renderReferenceIdCell,
  renderDateTimeCell,
  renderCustomerCell,
  renderCoatingCell,
  renderLnamCell,
  renderLabelsCell,
} from "../table/orderTableCells";

class UnderProcessingTab extends Component {
  columns = [
    {
      title: "Order No.",
      dataIndex: "internal_order_id",
      sorter: (a, b) => a.internal_order_id - b.internal_order_id,
      sortDirections: ["ascend"],
      render: (text, record, index) =>
        renderOrderNumberCell(text, record, () =>
          this.props.getOrderDetailsForPage(record.id, index)
        ),
    },
    {
      title: "Reference Id",
      dataIndex: "reference_id",
      render: renderReferenceIdCell,
    },
    {
      title: "Entry Date & Time",
      dataIndex: "received_date",
      render: renderDateTimeCell,
    },
    {
      title: "Coating",
      dataIndex: "coating.value",
      mobileHidden: true,
      render: renderCoatingCell,
    },
    {
      title: "LNAM",
      dataIndex: "lnam.name",
      mobileHidden: true,
      render: renderLnamCell,
    },
    {
      title: "Customer",
      dataIndex: "customer.name",
      mobileHidden: true,
      render: renderCustomerCell,
    },
    {
      title: "Promise Date & Time",
      dataIndex: "promised_date",
      mobileHidden: true,
      render: renderDateTimeCell,
    },
    {
      title: "Labels",
      width: 150,
      mobileHidden: true,
      render: renderLabelsCell,
    },
    {
      title: "Current Status",
      width: 150,
      mobileHidden: true,
      render: (text, record) => {
        const userType = getUserType();
        const statuses = (record && record.lensware_status) || [];
        if (!statuses.length) {
          return <span className="order-cell-muted">—</span>;
        }
        return (
          <div className="order-labels-cell">
            {statuses.map((item, index) => (
              <span className="order-chip order-chip--status" key={index}>
                {item.status &&
                  item.status[lenswareStatusUserMapping[userType]]}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      title: "Tray No.",
      width: 150,
      mobileHidden: true,
      render: (text, record) => {
        const statuses = (record && record.lensware_status) || [];
        if (!statuses.length) {
          return <span className="order-cell-muted">—</span>;
        }
        return (
          <div className="order-tray-cell">
            {statuses.map((item, index) => (
              <span className="order-tray-no" key={index}>
                {item.tray || "—"}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      title: "Transport Mode",
      dataIndex: "dispatch_type.value",
      mobileHidden: true,
      render: (text) =>
        text ? (
          <span className="order-chip order-chip--dispatch">{text}</span>
        ) : (
          <span className="order-cell-muted">—</span>
        ),
    },
    {
      title: "Right Dia",
      dataIndex: "right_lens_config.dia",
      mobileHidden: true,
      render: (text) =>
        text != null ? text : <span className="order-cell-muted">—</span>,
    },
    {
      title: "Left Dia",
      dataIndex: "left_lens_config.dia",
      mobileHidden: true,
      render: (text) =>
        text != null ? text : <span className="order-cell-muted">—</span>,
    },
    {
      title: "Right Ellh",
      dataIndex: "right_lens_config.ellh",
      mobileHidden: true,
      render: (text) =>
        text != null ? text : <span className="order-cell-muted">—</span>,
    },
    {
      title: "Left Ellh",
      dataIndex: "left_lens_config.ellh",
      mobileHidden: true,
      render: (text) =>
        text != null ? text : <span className="order-cell-muted">—</span>,
    },
    {
      title: "Actions",
      fixed: "right",
      width: 100,
      className: "order-actions-column",
      render: (text, record) => {
        const userPermissions = getUserPermissions();
        return (
          <MobileOrderActions>
            <PermissibleRender
              userPermissions={userPermissions}
              requiredPermissions={["can_add_label"]}
            >
              <Button
                className="order-action-btn"
                size="small"
                type="primary"
                onClick={() =>
                  this.props.openModal("CreateLabelModal", { id: record.id })
                }
              >
                Add Label
              </Button>
            </PermissibleRender>
            <PermissibleRender
              userPermissions={userPermissions}
              requiredPermissions={["can_link_order"]}
            >
              <Button
                className="order-action-btn"
                size="small"
                type="primary"
                onClick={() =>
                  this.props.openModal("LinkedOrderModal", {
                    type: "linkOldOrder",
                    linkingOrderId: record.id,
                  })
                }
              >
                Link Order
              </Button>
            </PermissibleRender>
          </MobileOrderActions>
        );
      },
    },
  ];

  render() {
    const { loading, orders, fetchProcessingOrders } = this.props;
    const results = (orders && orders.results) || [];
    const total = (orders && orders.count) || 0;

    return (
      <div className="home-order-tab-pane">
        <Table
          columns={this.columns}
          loading={loading}
          data={results}
          rowClassName={getOrderRowClassName}
          pagination={false}
          bordered={false}
          size="middle"
        />
        <Paginater
          defaultCurrent={1}
          total={total}
          onChange={fetchProcessingOrders}
          pageSize={ORDER_LIST_PAGE_SIZE}
        />
      </div>
    );
  }
}

const actions = {
  fetchProcessingOrders,
  getOrderDetailsForPage,
  openModal,
};

const mapStateToProps = (state) => ({
  loading: state.home.loadingProcessingOrders,
  orders: state.home.processingOrders,
  activeTabKey: state.home.activeTabKey,
});

export default connect(
  mapStateToProps,
  actions
)(UnderProcessingTab);
